/* src/app/shared/components/rl-dialog/rl-dialog.component.scss */
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal {
  background-color: #fff;
  width: 100%;
  text-align: center;
  padding: 20px;
}
.modal-heading {
  font-size: 24px;
  color: #003a71;
}
.modal-content {
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.modal-buttons {
  margin-top: 20px;
}
.btn-save,
.btn-cancel {
  padding: 10px;
  margin: 0 10px;
  width: 120px;
  cursor: pointer;
  border: none;
  border-radius: 20px;
  font-size: 14px;
}
.btn-save {
  background-color: #003a71;
  color: #fff;
}
.btn-cancel {
  background-color: #f4f0e5;
}
.btn-save:hover,
.btn-cancel:hover {
  opacity: 0.8;
}
.disabled-button {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
/*# sourceMappingURL=rl-dialog.component.css.map */
